// extracted by mini-css-extract-plugin
module.exports = {"main":"MainList-MainList-main-3093ce46"};